import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'c-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnInit {

  @Input() value: any;

  constructor() { }

  ngOnInit() {
  }

}
